/* istanbul ignore file */
import Login from './Login';

export default Login;
